import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * The pane's text-field look, shared by Input and Textarea: the MUI outlined-small it
 * replaces, whose border turns the accent on focus.
 */
const inputClass =
  "w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 text-[13px] text-foreground transition-colors outline-none placeholder:text-disabled hover:border-grey-400 focus-visible:border-primary focus-visible:ring-1 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(inputClass, "h-8 py-1", className)}
      {...props}
    />
  )
);
Input.displayName = "Input";

export { Input, inputClass };
